module.exports = __webpack_public_path__ + "static/media/ic_optimizer_background.29e179db.jpg";